(function () {
  'use strict';

  var current = null;

  function activate(thumbs, index, scroll) {
    thumbs.forEach(function (thumb) {
      thumb.classList.remove('is-active');
    });
    var active = thumbs[index];
    if (!active) return;
    active.classList.add('is-active');
    if (scroll) {
      active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  function bind() {
    var mainSlider = document.querySelector('.js-product-hero-main-slider');
    var thumbNav = document.querySelector('.js-product-hero-main-nav');
    var jquery = window.jQuery || window.$;
    if (!mainSlider || !thumbNav || !jquery) {
      destroy();
      return null;
    }

    var thumbs = Array.prototype.slice.call(thumbNav.querySelectorAll('.product-hero-main-nav__slide'));
    if (thumbs.length === 0) {
      destroy();
      return null;
    }
    if (
      current &&
      current.mainSlider === mainSlider &&
      current.thumbNav === thumbNav &&
      current.thumbs.length === thumbs.length &&
      current.thumbs.every(function (thumb, index) { return thumb === thumbs[index]; })
    ) return current;
    destroy();

    var $slider = jquery(mainSlider);
    var clickListeners = thumbs.map(function (thumb, index) {
      var listener = function (event) {
        event.preventDefault();
        event.stopPropagation();
        activate(thumbs, index, false);
        if ($slider.hasClass('slick-initialized')) $slider.slick('slickGoTo', index);
      };
      thumb.addEventListener('click', listener);
      return listener;
    });

    function onAfterChange(_event, _slick, currentSlide) {
      activate(thumbs, currentSlide, true);
    }

    $slider.off('.florafyThumbnailNav');
    $slider.on('afterChange.florafyThumbnailNav', onAfterChange);
    activate(thumbs, $slider.hasClass('slick-initialized') ? $slider.slick('slickCurrentSlide') : 0, false);

    var resizeObserver = null;
    var heightFrame = null;
    function syncHeight() {
      heightFrame = null;
      var height = mainSlider.offsetHeight;
      if (height > 0) thumbNav.style.setProperty('--main-image-height', height + 'px');
    }
    function scheduleHeightSync() {
      if (heightFrame !== null) return;
      heightFrame = window.requestAnimationFrame(syncHeight);
    }
    if (typeof window.ResizeObserver === 'function') {
      resizeObserver = new window.ResizeObserver(scheduleHeightSync);
      resizeObserver.observe(mainSlider);
    }
    scheduleHeightSync();

    current = {
      mainSlider: mainSlider,
      thumbNav: thumbNav,
      thumbs: thumbs,
      destroy: function () {
        thumbs.forEach(function (thumb, index) {
          thumb.removeEventListener('click', clickListeners[index]);
        });
        $slider.off('.florafyThumbnailNav');
        if (resizeObserver) resizeObserver.disconnect();
      },
    };
    return current;
  }

  function destroy() {
    if (!current) return;
    var handle = current;
    current = null;
    handle.destroy();
  }

  window.florafyThumbnailNav = { bind: bind, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
  window.addEventListener('combined-listing:swapped', bind);
})();
